import React, {useState} from "react";
import ProgramBasics from "../components/Forms/ProgramBasic";
import {Tabs, TabsHeader, TabsBody, Tab} from "@material-tailwind/react";
import Session from "../components/Forms/ProgramSession";
import Question from "../components/Forms/ProgramQuestion";
import CounsellingSessions from "../components/Forms/ProgramCounsellingSlots";
import {toast} from "react-toastify";

export default function Program() {
    const [activeTab, setActiveTab] = useState<number>(0);
    const [programId, setProgramId] = useState<string | undefined>();
    const [startDate, setStartDate] = useState<string | undefined>();

    const updateProgramId = (programIdAdded: string) => {
        if (programIdAdded) {
            setProgramId(programIdAdded);
        }
    };
    const updateStartDate = (allStartDate: string) => {
        if (allStartDate) {
            setStartDate(allStartDate);
        }
    };
    

    const handleTabChange = (index: number) => {
        const newProgramId = programId ? programId : localStorage.getItem('programId')
         
        if (index !== 0 && !newProgramId) {
            toast.warning("Please fill out program basic details before proceeding");
        } else {
            setActiveTab(index);
        }
    };

    const chnageTab = (index: number) => {
        setActiveTab(index);
    };
    return (
        <>
            <h2 className="py-1 pb-4 text-2xl font-gilroy font-semibold text-[#263238]">
                Add New Program
            </h2>
            <div className="bg-white h-[calc(100vh-190px)] overflow-y-hidden rounded-md py-2">
                <Tabs>
                    <TabsHeader className="border-b-2  rounded-none mx-6 ">
                        <Tab
                            key="Basic"
                            value="Basic"
                            onClick={() => handleTabChange(0)}
                            className={`w-48 text-[#B0BEC5] border-b-2 custom-mb-minus-5 border-[#ECEFF1] ${
                                activeTab === 0 ? "active" : ""
                            }  `}
                        >
                            Basic
                        </Tab>
                        <Tab
                            key="Sessions"
                            value="Sessions"
                            onClick={() => handleTabChange(1)}
                            className={`w-48 text-[#B0BEC5] border-b-2 custom-mb-minus-5 border-[#ECEFF1]  ${
                                activeTab === 1 ? "active" : ""
                            }  `}
                        >
                            Sessions
                        </Tab>
                        <Tab
                            key="Question"
                            value="Question"
                            onClick={() => handleTabChange(2)}
                            className={`w-48 text-[#B0BEC5] border-b-2 custom-mb-minus-5 border-[#ECEFF1]  ${
                                activeTab === 2 ? "active" : ""
                            }  `}
                        >
                            Questions
                        </Tab>
                        <Tab
                            key="Counselling"
                            value="Counselling"
                            onClick={() => handleTabChange(3)}
                            className={`w-48 text-[#B0BEC5] border-b-2 custom-mb-minus-5 border-[#ECEFF1]  ${
                                activeTab === 3 ? "active" : ""
                            } `}
                        >
                            1-1 Counselling
                        </Tab>
                    </TabsHeader>

                    <TabsBody>
                        <div className={activeTab === 0 ? "tab-panel active" : "tab-panel"}>
                            {activeTab === 0 && (
                                <ProgramBasics
                                    chnageTab={() => chnageTab(1)}
                                    updateProgramId={updateProgramId}
                                    updateStartDate={updateStartDate}
                                    programId={programId}
                                />
                            )}
                        </div>
                        <div className={activeTab === 1 ? "tab-panel active" : "tab-panel"}>
                            {activeTab === 1 && <Session programId={programId} startDate={startDate}/>}
                        </div>
                        <div className={activeTab === 2 ? "tab-panel active" : "tab-panel"}>
                            {activeTab === 2 && <Question programId={programId}/>}
                        </div>
                        <div className={activeTab === 3 ? "tab-panel active" : "tab-panel"}>
                            {activeTab === 3 && <CounsellingSessions programId={programId}/>}
                        </div>
                    </TabsBody>
                </Tabs>
            </div>
        </>
    );
}
